module.exports = __webpack_public_path__ + "img/codeigniter.8c8c3ae5.svg";